<template>
  <div class="data-card">
    <span class="card-value">{{ value }}</span>
    <p class="card-title">{{ title }}</p>
  </div>
</template>

<script>
export default {
  props: {
    value: [Number, String],
    title: String
  }
};
</script>

<style scoped>
.data-card {
  background-color: #e06666ff; /* Soft orange-rose color */
  border-radius: 20px;
  padding: 40px;
  margin: 30px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 310px;
  height: 200px;
}

.card-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #ffffff;
}

.card-value {
  font-size: 60px;
  color: #ffffff;
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/brand/health/components/aggregate/DataCard.vue